import { StatusTag } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { getScheduleStatusVariant } from '@modules/borrower/utils/getScheduleStatusVariant';
const getStatusColumn = ({ row: { original } }) => {
    const { t } = useTranslation();
    const label = t(`financing.loan_status.${original.status.toLowerCase()}`);
    const variant = getScheduleStatusVariant(original.status);
    if (!variant) {
        return <span className="body-s text-neutral-secondary-initial">{label}</span>;
    }
    return <StatusTag variant={variant} label={label} isFilledIcon={false}/>;
};
export const getPaymentsScheduleColums = (t) => [
    {
        header: t('financing.payments_schedule.number'),
        accessorKey: 'position',
        size: 56,
        sortable: true,
    },
    {
        header: t('financing.payments_schedule.payment_date'),
        accessorKey: 'date',
        sortable: true,
    },
    {
        header: t('financing.payments_schedule.status'),
        accessorKey: 'status',
        cell: getStatusColumn,
    },
    {
        header: `${t('financing.payments_schedule.amount')}, €`,
        accessorKey: 'amount',
    },
    {
        header: `${t('financing.payments_schedule.interest')}, €`,
        accessorKey: 'interest',
    },
    {
        header: `${t('financing.payments_schedule.admin_fee')}, €`,
        accessorKey: 'administratorFee',
    },
    {
        header: t('financing.payments_schedule.overdue_days'),
        accessorKey: 'overdueDays',
    },
    {
        header: `${t('financing.payments_schedule.late_fees')}, €`,
        accessorKey: 'lateFee',
    },
    {
        header: `${t('financing.payments_schedule.sum')}, €`,
        accessorKey: 'sum',
    },
];
